<template>
    <div class="chart-time-bar">
        <div class="left">
            <el-radio-group size="small" @change="setTimeInterval" v-model="timeIntervalType">
                <el-radio-button :label="1">最近7天</el-radio-button>
                <el-radio-button :label="2">本月</el-radio-button>
                <el-radio-button :label="3">本年</el-radio-button>
            </el-radio-group>
            <el-date-picker size="small" @change="changeTimeInterval" v-model="timeInterval" :picker-options="pickerOptions"
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
        </div>
        <div class="right">
            <el-radio-group size="small" @change="updateValue(2)" v-model="chartType">
                <el-radio-button :label="1">按天</el-radio-button>
                <!-- <el-radio-button :label="3">按周</el-radio-button> -->
                <el-radio-button :label="2">按月</el-radio-button>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timeInterval: [], // 日期区间
            timeIntervalType: 1, // 日期类型
            chartType: 1 // 图表数据展示类型
        }
    },
    computed: {
        pickerOptions() {
            return {
                onPick: ({maxDate, minDate}) => {
                    // 获取2022年时间戳边界
                    const minValidDate = new Date('2021-12-31');
                    // 自动修正开始时间
                    if (minDate < minValidDate) {
                        this.$set(this.timeInterval, 0, minValidDate.getTime());
                    }
                    // 自动修正结束时间（当用户单独选择结束时间时）
                    if (maxDate && maxDate < minValidDate) {
                        this.$set(this.timeInterval, 1, minValidDate.getTime());
                    }
                },
                disabledDate: time => {
                    const minValidDate = new Date('2021-12-31').getTime();
                    return time.getTime() < minValidDate; // 禁用2022年前的日期
                }
            };
        }
    },
    mounted() {
        this.reset();
    },
    methods: {
        updateValue(type) {
            const data = { time: this.timeInterval, type: this.chartType };
            this.$emit('input', data);
            if (type === 1) {
                this.$emit('changeTime', data);
            } else {
                this.$emit('changeType', data);
            }
        },
        changeTimeInterval(value) {
            this.timeInterval = value;
            this.updateValue(1);
        },
        setTimeInterval(value) {
            if (value == 1) this.timeInterval = this.subtractDays(7);
            if (value == 2) this.timeInterval = this.subtractDays(30);
            if (value == 3) this.timeInterval = this.subtractDays(365);
            this.updateValue(1);
        },
        subtractDays(days) {
            const today = new Date();
            today.setDate(today.getDate() - (days === 7 ? 2 : 1));
            const result = new Date(today);
            if (days === 7) {
                result.setDate(result.getDate() - 6);
            } else if (days === 30) {
                result.setDate(1);
            } else if (days === 365) {
                result.setMonth(0);
                result.setDate(1);
            }
            return [result.getTime(), today.getTime()];
        },
        reset() {
            this.timeIntervalType = 1;
            this.chartType = 1;
            this.timeInterval = this.subtractDays(7);
            this.updateValue(1);
        }
    }
}
</script>


<style lang="scss">
.chart-time-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .left {

        .el-radio-group {
            margin-right: 20px;


        }

        .el-range-editor--small.el-input__inner {
            height: 36px;
        }
    }

    .el-radio-button--small .el-radio-button__inner {
        padding: 11px 15px;
        color: $-text-500;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: transparent;
        border-color: $--border-color-base;
        color: $-text-950;
        font-weight: bold;
        box-shadow: none;
    }

    .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
        box-shadow: none;
    }
}
</style>